/* UGC */
/*
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    const source = document.querySelector('.ugcBox--original');
    const target = document.querySelector('.ugcBox--mobile-target');
    
    console.warn('source:', source);
    console.warn('source innerHTML length:', source?.innerHTML?.length);
    console.warn('target:', target);

    if (!source || !target) return;

    const clone = source.cloneNode(true);
    target.appendChild(clone);
    source.style.display = 'none';
  }, 1500);
});
*/
/*
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.quantity-preset');
  if (!btn) return;

  const form = btn.closest('form');
  if (!form) return;

  const quantity = Number(btn.dataset.quantity);

  // UI state scoped to form
  form.querySelectorAll('.quantity-preset').forEach(b => {
    b.classList.remove('product-quantity__card--active');
  });
  btn.classList.add('product-quantity__card--active');

  const input = form.querySelector('input[name="quantity"]');
  if (!input) return;

  input.value = quantity;

  input.dispatchEvent(new Event('input', { bubbles: true }));
  input.dispatchEvent(new Event('change', { bubbles: true }));
});
*/

const overlay = document.querySelector('.productFormOverlay');

document.addEventListener('submit', function (e) {
  if (e.target.matches('.productForm form')) {
    setTimeout(() => {
      closeAllForms();
    }, 300);
  }
});

function closeAllForms() {
  document.querySelectorAll('.productForm').forEach(f => f.classList.remove('open'));

  overlay?.classList.remove('active');
  document.body.classList.remove('no-scroll');
}

function handleize(str) {
  return str
    .toLowerCase()
    .normalize('NFD')                 // remove accents
    .replace(/[\u0300-\u036f]/g, '')  // remove diacritics
    .replace(/[^a-z0-9]+/g, '-')      // replace non-alphanumeric with -
    .replace(/^-+|-+$/g, '');         // trim -
}


document.addEventListener('change', function (e) {
  const radio = e.target.closest('[data-use="var-selector"]');
  if (!radio) return;

  const formId = radio.getAttribute('form');
  const form = document.getElementById(formId);
  if (!form) return;

  const hiddenInput = form.querySelector('input[name="id"]');
  if (!hiddenInput) return;

  hiddenInput.value = radio.value;
});

/*
document.addEventListener('change', function (e) {
  const radio = e.target.closest('[data-use="var-selector"]');
  if (!radio) return;

  const form = radio.closest('form');
  
  console.log('Radio clicked:', radio.value);
  console.log('Form found:', form?.id);
  console.log('Hidden input found:', form?.querySelector('input[name="id"]')?.value);
  document.querySelector('[data-use="var-selector"]').closest('form')
  javascriptdocument.querySelector('[data-use="var-selector"]').parentElement
// keep calling .parentElement chain to see the actual DOM structure
});
*/

document.addEventListener('change', function (e) {
  const radio = e.target.closest('[data-use="var-selector"]');
  if (!radio) return;

  const form = radio.closest('form');
  if (!form) return;

  const basePrice = parseInt(radio.dataset.durationPrice, 10); // in cents
  if (!basePrice) return;

  const discounts = { 1: 0, 2: 5, 3: 10 }; // match your Liquid % off

  form.querySelectorAll('.quantity-preset').forEach(card => {
    const qty = parseInt(card.dataset.quantity, 10);
    const discount = discounts[qty] ?? 0;
    const multiplier = (100 - discount) / 100;

    const raw = basePrice * qty * multiplier;
    const discounted = Math.ceil(raw);
    const original = basePrice * qty;

    // Format as euros
    const fmt = (cents) => (cents / 100).toFixed(2).replace('.', ',') + '€';
    const fmtSavings = (cents) => Math.round(cents / 100) + '€';


    const priceEl = card.querySelector('.product-quantity__price');
    const ogPriceEl = card.querySelector('.product-quantity__og-price');

    if (priceEl) priceEl.textContent = fmt(discounted);

    if (discount > 0) {
      if (ogPriceEl) {
        ogPriceEl.textContent = fmt(original);
        ogPriceEl.style.display = '';
      }
    } else {
      if (ogPriceEl) ogPriceEl.style.display = 'none';
    }



    // Update savings badge
    const badge = card.querySelector('.badgeDiscount');
    if (badge && discount > 0) {
      const savings = original - discounted;
      badge.textContent = `Économisez ${fmtSavings(savings)}`;
    }
  });
});


document.addEventListener('submit', async function (e) {
  const form = e.target;
  if (!form.closest('.productForm')) return;

  e.preventDefault();

  // ✅ ALWAYS read from DOM (not stale FormData)
  const variantId = form.querySelector('input[name="id"]').value;
  const quantity = form.querySelector('[name="quantity"]')?.value || 1;

  const formData = new FormData(form);

  const properties = {};
  for (const [key, value] of formData.entries()) {
    if (key.startsWith('properties[')) {
      properties[key.replace('properties[', '').replace(']', '')] = value;
    }
  }

  try {
    await cartManager.addItem(
      variantId,
      parseInt(quantity, 10),
      properties,
      {
        // Meta Pixel : le vrai ajout au panier depuis le popup d'une product card.
        // onSuccess recoit la reponse de /cart/add.js => { items: [...] }
        onSuccess: (response) => trackFacebookAddToCart(response, quantity)
      }
    );

    // smoother than RAF + timeout combo
    requestAnimationFrame(() => {
      document.dispatchEvent(new CustomEvent('cart:update', {
        detail: { cart: null }
      }));
    });

  } catch (err) {
    console.error('Add to cart failed:', err);
  }
});

/**
 * Envoie l'event Add to Cart au pixel Meta a partir de la reponse de /cart/add.js.
 * Appel uniquement depuis les boutons qui ajoutent reellement au panier.
 */
function trackFacebookAddToCart(response, quantityToAdd = 1) {
  if (typeof window.fbq !== 'function') return;

  const items = response && Array.isArray(response.items) ? response.items : [response];
  const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';

  let value = 0;
  const contentIds = [];
  const contents = [];

  items.forEach((item) => {
    if (!item || !item.id) return;

    console.log('item:', item);

    const unitPrice = (item.final_price != null ? item.final_price : item.price || 0);
    const linePrice = item.final_line_price != null ? item.final_line_price : unitPrice * quantityToAdd;

    value += linePrice;
    contentIds.push(String(item.id));
    contents.push({
      id: String(item.id),
      product_id: String(item.product_id),
      quantity: quantityToAdd,
      item_price: unitPrice
    });
  });

  console.log({
    content_type: 'product',
    content_ids: contentIds,
    content_name: items[0].product_title || items[0].title,
    contents: contents,
    num_items: contents.reduce((total, content) => total + content.quantity, 0),
    value: Math.round(value * 100) / 100,
    currency: currency
  })
  
  if (!contentIds.length) return;

  window.fbq('trackCustom', 'Add to Cart', {
    content_type: 'product',
    content_ids: contentIds,
    content_name: items[0].product_title || items[0].title,
    contents: contents,
    num_items: contents.reduce((total, content) => total + content.quantity, 0),
    value: Math.round(value * 100) / 100,
    currency: currency
  });
}


/* render js form 
document.addEventListener('mouseover', function (e) {
  const card = e.target.closest('.card-wrapper');
  if (!card) return;

  const placeholder = card.querySelector('.productForm-placeholder');
  if (!placeholder || placeholder.dataset.loading === "true" || placeholder.dataset.loaded === "true") return;

  const handle = placeholder.dataset.handle;
  if (!handle) return;

  placeholder.dataset.loading = "true";

  fetch(`/products/${handle}?section_id=EE-product-card-overlay`)
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Extract just the section div Shopify wraps it in
      const sectionContent = doc.querySelector('#shopify-section-EE-product-card-overlay');

      if (sectionContent) {
        placeholder.innerHTML = sectionContent.innerHTML;
      } else {
        // Fallback: inject everything (not ideal)
        placeholder.innerHTML = html;
      }

      placeholder.dataset.loaded = "true";
    })
    .catch(err => {
      console.error(err);
      placeholder.dataset.loading = "false";
    });

}, true);*/

/* could remove, maybe put back if bugs
function updateBtnPrice(form) {
  const btn = form.querySelector('[data-btn-price]');
  if (!btn) return;

  const activeCard = form.querySelector('.product-quantity__card--active');
  if (!activeCard) return;

  const priceEl = activeCard.querySelector('.product-quantity__price');
  if (!priceEl) return;

  btn.textContent = priceEl.textContent.trim();
}

document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(form => {
  updateBtnPrice(form);
});
*/

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.quantity-preset');
  if (!btn) return;

  const form = btn.closest('form');
  if (!form) return;

  const quantity = Number(btn.dataset.quantity);

  form.querySelectorAll('.quantity-preset').forEach(b => {
    b.classList.remove('product-quantity__card--active');
  });
  btn.classList.add('product-quantity__card--active');

  const input = form.querySelector('input[name="quantity"]');
  if (!input) return;

  input.value = quantity;
  input.dispatchEvent(new Event('input', { bubbles: true }));
  input.dispatchEvent(new Event('change', { bubbles: true }));

  // updateBtnPrice(form);
});

document.addEventListener('change', function (e) {
  const radio = e.target.closest('[data-use="var-selector"]');
  if (!radio) return;

  const form = radio.closest('form');
  if (!form) return;

  const basePrice = parseInt(radio.dataset.durationPrice, 10);
  if (!basePrice) return;

  const discounts = { 1: 0, 2: 5, 3: 10 };

  form.querySelectorAll('.quantity-preset').forEach(card => {
    const qty = parseInt(card.dataset.quantity, 10);
    const discount = discounts[qty] ?? 0;
    const multiplier = (100 - discount) / 100;

    const raw = basePrice * qty * multiplier;
    const discounted = Math.ceil(raw);
    const original = basePrice * qty;

    const fmt = (cents) => (cents / 100).toFixed(2).replace('.', ',') + '€';
    const fmtSavings = (cents) => Math.round(cents / 100) + '€';

    const priceEl = card.querySelector('.product-quantity__price');
    const ogPriceEl = card.querySelector('.product-quantity__og-price');

    if (priceEl) priceEl.textContent = fmt(discounted);

    if (discount > 0) {
      if (ogPriceEl) {
        ogPriceEl.textContent = fmt(original);
        ogPriceEl.style.display = '';
      }
    } else {
      if (ogPriceEl) ogPriceEl.style.display = 'none';
    }

    const badge = card.querySelector('.badgeDiscount');
    if (badge && discount > 0) {
      const savings = original - discounted;
      badge.textContent = `Économisez ${fmtSavings(savings)}`;
    }
  });

  // updateBtnPrice(form); // runs after cards are updated so it reads the correct price
});



/* test differential loading */
function formatMoney(cents, currencySymbol) {
  return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0' + (currencySymbol || '€');
}

function buildForm(product, variantColors = {}) {
  const variant = product.variants[0];
  const currencySymbol = window.Shopify?.currency?.active || '€';


  // Build variants HTML if multiple
  let variantsHTML = '';
  if (product.variants.length > 1) {
    const optionName = product.options?.[0]?.name || '';
    variantsHTML = `
      <div class="varBoxContainer">
        <fieldset class="js product-form__input product-form__input--pill card-variant-picker is-${optionName}">
          <input type="hidden" name="id" value="${variant.id}">
          <legend class="form__label legendCard uppercase">${optionName}</legend>
          ${product.variants.map(v => `
            <input
              data-use="var-selector"
              type="radio"
              id="card-var-${v.id}"
              name="id-${product.id}"
              value="${v.id}"
              data-duration-price="${v.price}"
              data-currency="${currencySymbol}"
              ${v.id === variant.id ? 'checked' : ''}
              ${!v.available ? 'disabled' : ''}
            >
            <label for="card-var-${v.id}" class="product-variant__label is-${handleize(v.option1)}">
              ${variantColors[v.id] ? `<div class="product-variant__dot" style="background: ${variantColors[v.id]}; display: block;"></div>` : ''}
              ${v.option1}
              <span class="visually-hidden label-unavailable">Indisponible</span>
            </label>
          `).join('')}
        </fieldset>
      </div>
    `;
  } else {
    variantsHTML = `<input type="hidden" name="id" value="${variant.id}">`;
  }

  // Build quantity presets
  const discounts = [0, 5, 10];
  const presetsHTML = discounts.map((discount, i) => {
    const qty = i + 1;
    const basePrice = variant.price; // in cents
    const originalTotal = basePrice * qty;
    const discountedTotal = Math.ceil(originalTotal * (1 - discount / 100));
    const savings = originalTotal - discountedTotal;


    const savingsBadge = discount > 0 ? `
      <div class="badgeDiscountBox flex justify-center">
        <div class="badge badgeDiscount uppercase">
          Économisez ${Math.floor(savings / 100)}€
        </div>
      </div>
    ` : '';

    const freeShipping = discountedTotal >= 6500 
      ? `<div class="flex tag">✓ Livraison offerte</div>` 
      : '';

    const ogPrice = discount > 0 
      ? `<div class="product-quantity__og-price">${formatMoney(originalTotal)}</div>` 
      : '';

    return `
      <div class="product-quantity__card quantity-preset ${qty === 2 ? 'product-quantity__card--active' : ''}" data-quantity="${qty}">
        ${savingsBadge}
        <div class="product-quantity__card-content">
          <div>
            <div class="product-quantity__duration">${qty} mois</div>
            <div class="product-quantity__products">${qty} produit${qty > 1 ? 's' : ''}</div>
          </div>
          <div class="product-quantity__item">
            <div>
              <div class="product-quantity__price">${formatMoney(discountedTotal)}</div>
              ${ogPrice}
            </div>
          </div>
          ${freeShipping}
        </div>
      </div>
    `;
  }).join('');

  // Default active preset (2nd one)
  const defaultIndex = 1; // 2nd card (0-based)
  const defaultQty = defaultIndex + 1;
  const defaultDiscount = discounts[defaultIndex];

  const defaultTotal = Math.ceil(
    variant.price * defaultQty * (1 - defaultDiscount / 100)
  );

  return `
    <form id="card-form-${product.id}" class="card-quick-form" data-type="add-to-cart-form">
      <div class="productFormHeader flex justify-between">
        <div class="bold">Options d'achat</div>
        <div class="closeProductForm composition__drawer-close">✕</div>
      </div>

      <legend class="form__label legendCard uppercase">Quantité</legend>
      <div class="quantity-presets product-quantity__wrapper">
        ${presetsHTML}
      </div>

      <input type="hidden" name="quantity" value="2" class="qty-input">

      ${variantsHTML}

      <button type="submit" name="add" class="product-form__submit button button--full-width button--primary">
        ${variant.available ? `Ajouter au panier <span class="dotSep"></span> <span data-btn-price>${formatMoney(defaultTotal)}</span>` : 'Épuisé'}
      </button>
    </form>
  `;
}

// Open form on click
document.addEventListener('click', function(e) {
  const trigger = e.target.closest('.openProductForm');
  if (!trigger) return;

  const wrapper = trigger.closest('.card-wrapper');
  const formEl = wrapper.querySelector('.productForm');
  const overlay = wrapper.querySelector('.productFormOverlay');
  closeAllForms();
  // Already loaded — just show
  if (formEl.dataset.loaded) {
    requestAnimationFrame(() => {
      formEl.classList.add('open');
      overlay.classList.add('is-active');
    });
    return;
  }

  const handle = formEl.dataset.productHandle;

  let variantColors = {};
  try {
    variantColors = JSON.parse(formEl.dataset.variantColors || '{}');
  } catch (err) {
    console.error('Invalid data-variant-colors:', err);
  }

  fetch(`/products/${handle}.js`)
  .then(r => r.json())
  .then(product => {
    formEl.innerHTML = buildForm(product, variantColors);
    formEl.dataset.loaded = 'true';
    initFormEvents(formEl, product); // only once

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        formEl.classList.add('open');
        overlay.classList.add('is-active');
      });
    });
  })
  .catch(err => console.error('Failed to load product form:', err));
});

// Form interaction — quantity presets + variant selection
function initFormEvents(formEl, product) {
  const qtyInput = formEl.querySelector('.qty-input');
  const btnPrice = formEl.querySelector('[data-btn-price]');

  // Quantity preset click
  formEl.querySelectorAll('.quantity-preset').forEach(card => {
    card.addEventListener('click', function() {
      formEl.querySelectorAll('.quantity-preset').forEach(c => c.classList.remove('product-quantity__card--active'));
      this.classList.add('product-quantity__card--active');
      qtyInput.value = this.dataset.quantity;
      updateButtonPrice(formEl, product);
    });
  });

  // Variant selection
  formEl.querySelectorAll('[data-use="var-selector"]').forEach(radio => {
    radio.addEventListener('change', function() {
      const variantId = this.value;
      const variant = product.variants.find(v => v.id == variantId);
      if (variant) {
        formEl.querySelector('[name="id"]').value = variantId;
        updateButtonPrice(formEl, product);
      }
    });
  });

  // Submit — add to cart via AJAX
  
}

function updateButtonPrice(formEl, product) {
  const selectedVariantId = formEl.querySelector('[name="id"]').value;
  const qty = parseInt(formEl.querySelector('.qty-input').value) || 1;
  const variant = product.variants.find(v => v.id == selectedVariantId);
  if (!variant) return;

  const discounts = [0, 5, 10];
  const discount = discounts[qty - 1] || 0;
  const price = Math.ceil(variant.price * qty * (1 - discount / 100));
  const btnPrice = formEl.querySelector('[data-btn-price]');
  if (btnPrice) btnPrice.textContent = (price / 100).toFixed(2).replace('.', ',') + '\u00a0€';

  // Sync sticky button
  const stickyBtnPrice = document.querySelector('.sticky__product-add [data-btn-price]');
  if (stickyBtnPrice) stickyBtnPrice.textContent = (price / 100).toFixed(2).replace('.', ',') + '\u00a0€';
}

function closeAllForms() {
  document.querySelectorAll('.productForm.open').forEach(el => el.classList.remove('open'));
  document.querySelectorAll('.productFormOverlay.is-active').forEach(el => el.classList.remove('is-active'));
}

// Close on overlay or X click
document.addEventListener('click', function(e) {
  if (e.target.closest('.closeProductForm') || e.target.matches('.productFormOverlay')) {
    closeAllForms();
  }
});

document.addEventListener('click', function(e) {
  const openForm = document.querySelector('.productForm.open');
  if (!openForm) return;

  const clickedInsideForm = e.target.closest('.productForm.open');
  const clickedTrigger = e.target.closest('.openProductForm');

  // If click is completely outside → close
  if (!clickedInsideForm && !clickedTrigger) {
    closeAllForms();
  }
});

/* toggle articles auteur */
document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.toggle-articles-btn');
  const container = document.querySelector('.articleContainer');
  if (!container || !buttons.length) return;

  buttons.forEach(btn => {
    btn.addEventListener('click', function () {
      const isHidden = container.classList.contains('hidden');

      container.classList.toggle('hidden');

      // update ALL buttons text (keep them in sync)
      buttons.forEach(b => {
        b.textContent = isHidden
          ? "Voir moins d'articles"
          : "Voir tous les articles";
      });
    });
  });
});


/* test reco add */
document.addEventListener('submit', async function (e) {
  const form = e.target;
  if (!form.closest('.product-recommendations')) return;

  e.preventDefault();

  const variantId = form.querySelector('input[name="id"]').value;
  const quantity = form.querySelector('[name="quantity"]')?.value || 1;

  try {
    await cartManager.addItem(variantId, parseInt(quantity, 10), {});

    requestAnimationFrame(() => {
      document.dispatchEvent(new CustomEvent('cart:update', {
        detail: { cart: null }
      }));
    });
  } catch (err) {
    console.error('Add to cart failed:', err);
  }
});

/* PRODUCT PAGE *//* PRODUCT PAGE *//* PRODUCT PAGE *//* PRODUCT PAGE *//* PRODUCT PAGE *//* PRODUCT PAGE *//* PRODUCT PAGE *//* PRODUCT PAGE *//* PRODUCT PAGE *//* PRODUCT PAGE */
function formatPrice(value) {
  return (value / 100).toFixed(2).replace('.', ',') + ' €';
}

function formatEuro(value) {
  return value.toFixed(2).replace('.', ',') + '€';
}

/* ---------------------------
   VARIANT / FALLBACK PRICE
----------------------------*/
// Add this near the top, before any updateDynamicPrice calls
const originalPriceEl = document.querySelector(
  '.price__regular .price-item, .price-item--regular, [data-product-price]'
);
const cachedBasePrice = originalPriceEl
  ? Math.round(parseFloat(
      originalPriceEl.textContent.replace(/[^\d,]/g, '').replace(',', '.')
    ) * 100)
  : 0;
  
function getActiveVariant() {
  const active = document.querySelector('variant-selects input[type="radio"]:checked');

  if (active && active.dataset.durationPrice) {
    return { price: parseInt(active.dataset.durationPrice, 10) || 0 };
  }

  // No radio with data-duration-price — read price directly from active card
  const activeCard = document.querySelector('.product-quantity__card--active');
  if (activeCard) {
    const priceEl = activeCard.querySelector('.product-quantity__price');
    if (priceEl) {
      const raw = priceEl.textContent.replace(/[^\d,]/g, '').replace(',', '.');
      return { price: Math.round(parseFloat(raw) * 100) };
    }
  }

  return null;
}

/* ---------------------------
   QUANTITY
----------------------------*/
function getActiveQuantity() {
  const active = document.querySelector('.product-quantity__card--active');
  return active ? parseInt(active.dataset.quantity, 10) || 1 : 1;
}

/* ---------------------------
   DISCOUNT %
----------------------------*/
function getActiveDiscount() {
  const active = document.querySelector('.product-quantity__card--active');
  return active ? parseInt(active.dataset.priceOff, 10) || 0 : 0;
}

/* ---------------------------
   MAIN ENGINE
----------------------------*/
function updateDynamicPrice() {
    const variant = getActiveVariant();
  if (!variant) return;

  const qty = getActiveQuantity();
  const discount = getActiveDiscount();

  // If no radio variant, price is already final (read from card)
  const hasRadioVariant = !!document.querySelector('variant-selects input[type="radio"]:checked[data-duration-price]');
  
  const basePrice = hasRadioVariant 
    ? variant.price  // unit price, needs qty * discount applied
    : variant.price; // already the final total from the card

  const baseTotal = hasRadioVariant ? variant.price * qty : variant.price;
  const finalTotal = hasRadioVariant ? Math.round(baseTotal * (1 - discount / 100)) : variant.price;
  const originalTotal = hasRadioVariant ? baseTotal : (() => {
    const ogEl = document.querySelector('.product-quantity__card--active .product-quantity__og-price');
    if (ogEl) {
      const raw = ogEl.textContent.replace(/[^\d,]/g, '').replace(',', '.');
      return Math.round(parseFloat(raw) * 100);
    }
    return finalTotal;
  })();

  const savings = originalTotal - finalTotal;

  const priceEls = document.querySelectorAll('.price-dynamic');
  const compareEls = document.querySelectorAll('.compare-at-price-dynamic');
  const badgeEls = document.querySelectorAll('.savings-dynamic');
  const dailyEls = document.querySelectorAll('.daily-dynamic span');
  const dividedEls = document.querySelectorAll('.price_divided_by_3');

  /* ---------------------------
     MAIN PRICE
  ----------------------------*/
  priceEls.forEach(el => {
    el.innerHTML = formatPrice(finalTotal);
  });

  /* ---------------------------
     COMPARE PRICE (FIXED RESET LOGIC)
  ----------------------------*/
  const shouldShowCompare = discount > 0 && baseTotal > finalTotal;

  compareEls.forEach(el => {
    if (shouldShowCompare) {
      el.innerHTML = formatPrice(baseTotal);
    } else {
      el.innerHTML = '';
    }
  });

  /* ---------------------------
     SAVINGS BADGE (€)
  ----------------------------*/
  badgeEls.forEach(el => {
    if (savings > 0) {
      el.innerHTML = `-${formatEuro(savings / 100)}`;
      el.style.display = 'block';
    } else {
      el.innerHTML = '';
      el.style.display = 'none';
    }
  });

  /* ---------------------------
     PRICE PER DAY (0.80 BASE)
  ----------------------------*/
  const baseDaily = parseFloat(window.productData?.dailyPrice || 0.8);
  const ratio = baseTotal > 0 ? finalTotal / baseTotal : 1;
  const daily = Math.round(baseDaily * ratio * 100) / 100;

  dailyEls.forEach(el => {
    el.innerHTML = `soit ${daily.toFixed(2).replace('.', ',')}€/jour`;
  });

  /* ---------------------------
     PRICE / 3
  ----------------------------*/
  dividedEls.forEach(el => {
    const perItem = Math.round(finalTotal / 3);
    el.innerHTML = formatPrice(perItem);
  });
}

/* ---------------------------
   EVENTS
----------------------------*/
document.querySelectorAll('variant-selects input[type="radio"]').forEach(input => {
  input.addEventListener('change', updateDynamicPrice);
});
/*
document.querySelectorAll('.product-quantity__card').forEach(card => {
  card.addEventListener('click', () => {
    document.querySelectorAll('.product-quantity__card')
      .forEach(c => c.classList.remove('product-quantity__card--active'));

    card.classList.add('product-quantity__card--active');

    updateDynamicPrice();
  });
});
*/
/* ---------------------------
   INIT
----------------------------*/
document.addEventListener('DOMContentLoaded', updateDynamicPrice);


/* Toggle form sticky add to cart */
document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.sticky__product-toggle');
  const collapsible = document.querySelector('.sticky__product-collapsible');
  const label = document.querySelector('.sticky__label');

  const overlay = document.createElement('div');
  overlay.className = 'sticky__overlay';
  document.body.appendChild(overlay);

  function open() {
    collapsible.classList.add('open');
    overlay.classList.add('open');
    toggle.classList.add('is-open');
    label.textContent = 'Masquer les options disponibles';
    document.body.style.overflow = 'hidden';
  }

  function close() {
    collapsible.classList.remove('open');
    overlay.classList.remove('open');
    toggle.classList.remove('is-open');
    label.textContent = 'Afficher les options disponibles';
    document.body.style.overflow = '';
  }

  if (!toggle || !collapsible) return;

  toggle.addEventListener('click', () => {
    collapsible.classList.contains('open') ? close() : open();
  });

  overlay.addEventListener('click', close);
});
/* sticky add */
document.addEventListener("DOMContentLoaded", () => {
  const sticky = document.querySelector(".sticky__product");
  const target = document.querySelector(".product-form__buttons");

  if (!sticky || !target) return;

  const mobileQuery = window.matchMedia("(max-width: 749px)");

  let targetPassed = false; // true only once the button has scrolled above the viewport
  let lastScrollY = window.scrollY;
  let scrollingUp = false;

  function update() {
    const isCollapsibleOpen = document.querySelector('.sticky__product-collapsible')?.classList.contains('open');
    const hideBecauseScrollUp = mobileQuery.matches && scrollingUp;
    sticky.classList.toggle("is-active", targetPassed && !hideBecauseScrollUp || isCollapsibleOpen);
  }

  const observer = new IntersectionObserver(
    ([entry]) => {
      // "passed" = not intersecting AND it's above the viewport (scrolled past), not below it (not yet reached)
      targetPassed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      update();
    },
    { root: null, threshold: 0 }
  );

  observer.observe(target);

  window.addEventListener(
    "scroll",
    () => {
      const y = window.scrollY;
      // 5px deadzone so tiny jitters (iOS bounce, etc.) don't flicker the bar
      if (Math.abs(y - lastScrollY) > 5) {
        scrollingUp = y < lastScrollY;
        lastScrollY = y;
        update();
      }
    },
    { passive: true }
  );

  // re-evaluate if the viewport crosses the 750px boundary (rotation, resize)
  mobileQuery.addEventListener("change", update);
});







/* Mirror form */
document.addEventListener('mousedown', function (e) {
  const label = e.target.closest('.product-form__input--pill label');
  if (!label) return;

  const radio = document.getElementById(label.htmlFor);
  if (!radio) return;

  e.preventDefault();
  radio.focus({ preventScroll: true });
  radio.checked = true;
  radio.dispatchEvent(new Event('change', { bubbles: true }));

  // Sync counterpart by matching value
  document.querySelectorAll('.product-form__input--pill input[type="radio"]').forEach(other => {
    if (other === radio) return;
    if (other.value === radio.value) {
      other.checked = true;
      other.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  updateDynamicPrice();
});

document.addEventListener('click', function (e) {
  const card = e.target.closest('.quantity-preset');
  if (!card) return;

  const qty = card.dataset.quantity;

  // Remove active from all cards across both forms
  document.querySelectorAll('.quantity-preset').forEach(c => {
    c.classList.remove('product-quantity__card--active');
  });

  // Add active to all cards with matching quantity
  document.querySelectorAll(`.quantity-preset[data-quantity="${qty}"]`).forEach(c => {
    c.classList.add('product-quantity__card--active');
  });

  // Sync hidden quantity inputs
  document.querySelectorAll('input[name="quantity"]').forEach(input => {
    input.value = qty;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  updateDynamicPrice();

  // updateDynamicPrice() above has no notion of the subscription discount, so it
  // clobbers price-dynamic/daily-dynamic back to the plain price. Re-apply the
  // subscription-aware pass last so it has the final say when subscribed.
  document.querySelectorAll('subscribe-products').forEach((el) => {
    if (typeof el.updatePrice === 'function') el.updatePrice();
  });
});

/* "Je m'abonne" link in the green cure-longue note: select the 1-unit quantity
   and check the subscription box, on top of the scroll-to-top it already does */
document.addEventListener('click', function (e) {
  const link = e.target.closest('.image-text__note a');
  if (!link) return;

  document.querySelector('.quantity-preset')?.click();

  const subscribeCheckbox = document.querySelector('subscribe-products input[type="checkbox"]');
  if (subscribeCheckbox && !subscribeCheckbox.disabled && !subscribeCheckbox.checked) {
    subscribeCheckbox.click();
  }
});

/* popup */
document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('.pharma-modal');
  if (!modal) return; // add this

  let stockistScriptLoaded = false;
  const loadStockistWidget = () => {
    if (stockistScriptLoaded) return;
    stockistScriptLoaded = true;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://stockist.co/embed/v1/widget.min.js';
    document.body.appendChild(script);
  };

  document.querySelectorAll('.openPharma').forEach(button => {
    button.addEventListener('click', e => {
      e.preventDefault();
      loadStockistWidget();
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  });

  const closeModal = () => {
    modal.classList.remove('active');
    document.body.style.overflow = '';
  };

  modal.querySelector('.pharma-modal__close')
    .addEventListener('click', closeModal);

  modal.querySelector('.pharma-modal__overlay')
    .addEventListener('click', closeModal);

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeModal();
  });
});


document.addEventListener('DOMContentLoaded', () => {
  // console.log('cachedBasePrice:', cachedBasePrice);
  // console.log('qty:', getActiveQuantity());
  // console.log('discount:', getActiveDiscount());
  updateDynamicPrice();
});

/* toggle open accordeons */
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('section'); // or your specific section selector

  sections.forEach((section) => {
    const detailsElements = section.querySelectorAll('.statistique__faq-questions details');

    detailsElements.forEach((detail) => {
      detail.addEventListener('toggle', () => {
        if (detail.open) {
          detailsElements.forEach((otherDetail) => {
            if (otherDetail !== detail) {
              otherDetail.removeAttribute('open');
            }
          });

          // Questions can be long, so opening one further down the page can leave its summary
          // hidden behind the sticky header/sub-nav, or the item overflowing past the bottom of
          // the screen. Desktop and mobile both use a sticky header, so check on both. Only
          // scroll when the opened item isn't already fully visible.
          requestAnimationFrame(() => {
            const summary = detail.querySelector('summary');
            if (!summary) return;

            const headerEl = document.getElementById('shopify-section-header') || document.querySelector('.section-header');
            const tabsEl = document.querySelector('.scroll-buttons__section');
            const headerHeight = headerEl ? headerEl.getBoundingClientRect().height : 0;
            const tabsHeight = tabsEl ? tabsEl.getBoundingClientRect().height : 0;
            const stickyOffset = headerHeight + tabsHeight;

            const summaryTop = summary.getBoundingClientRect().top;
            const detailBottom = detail.getBoundingClientRect().bottom;
            const viewportHeight = window.innerHeight;

            const summaryHiddenBySticky = summaryTop < stickyOffset;
            const itemFullyVisible = detailBottom <= viewportHeight;

            if (summaryHiddenBySticky || !itemFullyVisible) {
              const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
              const topGap = rootFontSize + 1; // 1rem + 1px, keeps the item's top border visible below the sticky header/sub-nav
              const targetTop = summaryTop + window.pageYOffset - stickyOffset - topGap;
              window.scrollTo({ top: targetTop, behavior: 'smooth' });
            }
          });
        }
      });
    });
  });
});